module.exports = __webpack_public_path__ + "img/c06_unittechchariotarcherchampion_Normal_ua.665b211a.webp";